import { legTypes } from '@/apis/shipment';
import type { NavigateFunction } from 'react-router-dom';

/**
 * Navigate to the full-screen external map view for a shipment.
 *
 * Before pushing the map route, the current history entry is replaced with
 * `/shipment?shipment_id=<id>` (merging into any existing search params) so
 * that browser Back — and the map page's back arrow — both return to Control
 * Tower with the Detail drawer already open.
 */
export function navigateToExternalMapView(
  navigate: NavigateFunction,
  shipmentId: string,
  currentSearch = '',
  legType?: legTypes
) {
  const params = new URLSearchParams(currentSearch);
  params.set('shipment_id', shipmentId);
  if (legType) {
    params.set('leg_type', legType);
  }
  navigate(`/shipment?${params.toString()}`, { replace: true });

  const externalParams = new URLSearchParams();
  if (legType) {
    externalParams.set('leg_type', legType);
  }
  const searchStr = externalParams.toString();
  const url = `/shipment/external-view/${shipmentId}${searchStr ? `?${searchStr}` : ''}`;
  navigate(url);
}

/**
 * Navigate back to Control Tower, reopening the Detail drawer when a
 * shipment ID is available.
 */
export function navigateBackToShipmentDetail(
  navigate: NavigateFunction,
  shipmentId?: string | null,
  legType?: string
) {
  if (!shipmentId) {
    navigate('/shipment');
    return;
  }
  const params = new URLSearchParams();
  params.set('shipment_id', shipmentId);
  if (legType) {
    params.set('leg_type', legType);
  }
  navigate(`/shipment?${params.toString()}`);
}
